/**
 * @author Ariel
 * @Date 2023/2/2
 */
import React from "react";
import { component_tool } from '../../../tool';
import './index.less'

let { WizModal, WizCard } = component_tool;

let componentName = 'inviteLetter';

const columns = [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '业务类型',
    name: 'bizType',
    searchItem: {
      type: 'select',
      formatInit: () => 15
    },
    tableItem: {},
    dict: [
      {code: 15, codeName: '报名'}
    ]
  },
  {
    title: '标题',
    name: 'title',
    searchItem: {},
    tableItem: {},
  },
  {
    title: '状态',
    name: 'state',
    searchItem: {
      type: 'select',
    },
    tableItem: {},
    dict: [
      {code: 0, codeName: '关闭'},
      {code: 1, codeName: '打开'}
    ]
  }
];

const templateConfig = ({_btnFun}) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps:{
          buttonSort: ['add'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/biz/inviteLetter/add'
                }
              }
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'openOrClose', 'look', 'download'],
        rowOperateProps: {
          // width: 80,
          // fixed: 'right',
        },
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/biz/inviteLetter/update"
              }
            }
          },
          {
            key: "openOrClose",
            custom: true,
            params: { children: "打开" },
            textFormat: {
              recordKey: 'state',
              dirt: { '1': '关闭', '0': '打开', }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "打开" : "关闭"
                }该模版吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 1 ? 0 : 1,
                      ids: [record['id']],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  footer: null,
                  style: {minWidth: 700},
                  diy: (e) => {
                    let record = e && e['record']
                    return (
                      <WizCard title={record['title']}>
                        <div className="look-template" dangerouslySetInnerHTML={{__html: record['content']}}/>
                      </WizCard>
                    )
                  }
                }
              },
              formatParams: (rows, record, filters, callback) => {
                return {...record}
              }
            }
          },
          {
            key: "download",
            name: 'WizButton',
            params: {
              children: '下载',
              key: 'download',
            },
            onClick: (e) => _btnFun && _btnFun(e)
          },
        ],
        commonOperate: {
          add: true,
          enable: true,
          edit: true
        }
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
};

let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
